<template>
  <div>
    <el-form class="section top" style="flex-direction: row;line-height: 28px;min-width: 1600px;">
      <el-checkbox v-model="job.booking" :disabled="readonly" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
      <el-checkbox
        v-model="job.customs"
        :disabled="readonly"
        no="customs"
        @change="val=>{job.customsBroker=val?job.customsBroker:0;job.customsDeclarationType=val?job.customsDeclarationType:-1}"
      >{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
      <el-checkbox
        v-model="job.comercialInspectation"
        :disabled="readonly"
        no="comercialInspectation"
      >{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="job.heating" :disabled="readonly" no="heating">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="job.itmService" :disabled="readonly" no="itmService">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
      <el-checkbox
        v-model="job.headwayTail"
        :disabled="readonly"
        no="headwayTail"
      >{{ $t('RailwayExport.isHeadwayTail') }}</el-checkbox>
      <el-button
        v-permission="['button_insurance_toInsure']"
        :disabled="isEdit"
        no="toInsure"
        type="primary"
        @click="toInsure"
      >{{ $t('SeaExport.Insure') }}</el-button>
      <span style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
      <el-radio-group v-model="job.lob" :disabled="readonly" no="lob" style="margin-left: 10px;" @change="lobChangeHandler">
        <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
        <el-radio no="RI" label="RI">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
      </el-radio-group>
    </el-form>
    <div class="section top" style="min-width: 1600px;">
      <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
      <el-form
        :disabled="readonly"
        :inline="true"
        label-width="135px"
        label-position="left"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')" label-width="125px">
          <el-input v-model="job.jobNo" no="jobNo" :disabled="true" class="job-no-color input2" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_WarehouseNo')">
          <el-input v-model="job.warehouseNo" no="warehouseNo" class="input2" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.quotationNum')">
          <el-input no="quotationNo" :value="job.quotationNo" class="input2" :disabled="true" />
        </el-form-item>
      </el-form>
      <div>
        <div>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item label-width="125px">
              <span slot="label" class="blue">{{ $t('Payment.consignationCompany') }}</span>
              <cargo-sales-company-select
                v-if="accountObjectControlMode === 2"
                no="customerId"
                :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
                :method-params="{customer:true,active:true}"
                :check-credit="true"
                :job="job"
                :default-value="job.customerId||''"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="txtCustomerId_changeHandler"
              />
              <cargo-company-select
                v-else
                no="customerId"
                :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
                :method-params="{customer:true, active:true}"
                :check-credit="true"
                :job="job"
                :default-value="job.customerId||''"
                :static-options="customerCmpList"
                :placeholder="$t('SeaExport.RequiredItem')"
                :custom-style="'width:260px'"
                @change="txtCustomerId_changeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.contactPerson')">
              <el-select
                v-model="job.customerContact"
                no="customerContact"
                class="input2"
                :disabled="!electricBusinessBtnEnable"
                filterable
                :allow-create="true"
                placeholder=""
                @change="tfLinkman_closeHandler"
              >
                <el-option
                  v-for="(item,index) in contactList"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')">
              <el-input
                v-model="job.contactTelephone"
                no="contactTelephone"
                class="input2"
                :disabled="!electricBusinessBtnEnable"
                maxlength="32"
              />
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')" label-width="100px">
              <el-input
                v-model="job.contactFax"
                no="contactFax"
                class="input2"
                :disabled="!electricBusinessBtnEnable"
                maxlength="32"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item class="blue" label-width="125px">
              <span slot="label" class="blue">{{ $t('Payment.sales') }}</span>
              <cargo-user-select
                no="sales"
                class="input2"
                :disabled="!(!job.trustFromJob&&electricBusinessBtnEnable&&(!validateCustomerSales||(isSpecifiedSalesBusiness&&validateCustomerSales)))"
                :method-params="{officeId:!isSpecifiedSalesBusiness&&salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="job.sales||''"
                :static-options="salesList"
                :placeholder="$t('SeaExport.RequiredItem')"
                @change="txtSales_changeHandler"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('queryJob.salesDepartment') }}</span>
              <cargo-department-new-select
                no="salesOffice"
                class="input2"
                :disabled="!(job.sales>0&&job.salesDepartment>0)"
                :sales-id="job.sales"
                :office-id="job.salesOffice"
                :department-id="job.salesDepartment"
                :show-office-prefix="false"
                placeholder=" "
                @change="p=>{job.salesDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item class="blue">
              <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input v-model="txtSalesOffice" no="txtSalesOffice" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" class="input2" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')" label-width="100px">
              <cargo-user-select
                no="cargoSalesId"
                class="input2"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                :static-options="cargoSalesList"
                placeholder=" "
                @change="cargoSalesChargeHandler"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('FileHistory.operation')" label-width="125px">
              <cargo-user-select
                no="op"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOfficeId}"
                :default-value="job.op||''"
                placeholder=" "
                :static-options="userPortRoleData.op"
                @change="txtOPChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.operationDepartment')">
              <cargo-department-select
                no="opDepartment"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :office-id="job.opOffice"
                :enables="true"
                :department-id="job.opDepartment"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="opOffice"
                class="input2"
                :disabled="isEntrustOrder()"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.opOffice||''"
                placeholder=" "
                @parentCallBack="p=>{job.opOffice=p.value;opOfficeChargeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.Documents')" label-width="100px">
              <cargo-user-select
                no="dc"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'doc',officeId:$store.getters.currentOfficeId}"
                :default-value="job.dc||''"
                :static-options="userPortRoleData.doc || dcList"
                placeholder=" "
                @change="dcChangeHandler"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('Payment.customerService')" label-width="125px">
              <cargo-user-select
                no="csr"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'csr',officeId:job.opOffice}"
                :default-value="job.csr||''"
                :static-options="userPortRoleData.csr || csrList"
                placeholder=" "
                @change="csrChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.planner')">
              <cargo-user-select
                no="planner"
                class="input2"
                :method-params="{category:'role',shape:'railwayLine',officeId:$store.getters.currentOfficeId}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.railwayLine"
                @change="txtPlannerChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                class="input2"
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHc ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')" label-width="100px">
              <cargo-user-select
                no="siteOP"
                class="input2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('Message.Customer_Service')" label-width="125px">
              <cargo-department-select
                no="csrDepartment"
                class="input2"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-advance-select
                no="csrOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.csrOffice||''"
                @parentCallBack="p=>{job.csrOffice=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.Documentation_Department')">
              <cargo-department-select
                no="dcDepartment"
                class="input2"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')" label-width="100px">
              <cargo-advance-select
                no="dcOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.dcOffice||''"
                @parentCallBack="p=>{job.dcOffice=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('Payment.businessReferenceNumber')" label-width="125px">
              <cargo-input v-model="job.customerRefNo" no="customerRefNo" class="input2" :trim="true" />
            </el-form-item>
            <el-form-item :label="$t('Payment.itemNo')" :class="poNoRed?'poNoClass':''">
              <el-input v-model="job.poNo" no="poNo" class="input2" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.plannerDepartment')">
              <cargo-department-select
                no="plannerDepartment"
                class="input2"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.plannerOffice')">
              <cargo-advance-select
                no="plannerOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.plannerOffice||''"
                @parentCallBack="p=>{job.plannerOffice=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form v-if="isAddUserDefinedRoles" :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')" label-width="125px">
              <cargo-user-select
                no="userDefinedRoleId1"
                class="input2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole1"
                @change="userDefinedRoleId1Handler"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                no="userDefinedRoleId2"
                class="input2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole2"
                @change="userDefinedRoleId2Handler"
              />
            </el-form-item>
          </el-form>
        </div>
        <div v-show="job.preverifyState===3" style="display: flex;">
          <span style="width: 100px; display:inline-block">{{ $t('CargoMsg.Cargo_DenialReason') }}</span>
          <el-input v-model="job.bookingRefuseNote" no="bookingRefuseNote" type="textarea" style="width: 260px" :rows="3" :disabled="true" />
        </div>
      </div>
    </div>
    <div class="section" style="min-width: 1600px;">
      <span class="title">{{ $t('CargoMsg.Cargo_ShippingInformation') }}</span>
      <div class="form-item-w260" style="display: flex;flex-direction: row;">
        <el-form
          :disabled="readonly"
          label-width="125px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.Shipper')" class="auto-width">
            <cargo-company-select
              no="shipperId"
              :disabled="readonly"
              :method-params="{shipper:true,active:true}"
              :default-value="job.shipperId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateShipperList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="shipperChange"
            />&nbsp;
            <el-button
              no="CodeSearching"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="job['shipperLine'+i]"
              :no="'shipperLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.transportType') }}
            </span>
            <cargo-advance-select
              no="transportType"
              :select-type="TYPE_NAMES.basic_data_TransportationType"
              filterable
              :default-value="job.transportType"
              :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
              :tag-value="'code'"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{job.transportType=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.fullHalf') }}
            </span>
            <cargo-advance-select
              no="fullHalf"
              :select-type="TYPE_NAMES.local_cache_FullHalf"
              filterable
              :default-value="job.fullHalf"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{job.fullHalf=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.transportLine') }}
            </span>
            <cargo-advance-select
              no="transportLine"
              :select-type="TYPE_NAMES.basic_data_RailwayLine"
              filterable
              :default-value="job.transportLine"
              :placeholder="$t('SeaExport.RequiredItem')"
              tag-name="name"
              @parentCallBack="p=>{job.transportLine=p.value;onTransportLineChange()}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('RailwayExport.ETD2') }}</span>
            <el-date-picker v-model="job.etd" no="etd" type="date" value-format="yyyy-MM-dd" clearable :placeholder="$t('SeaExport.RequiredItem')" />
          </el-form-item>
          <el-form-item v-show="job.lob==='RE'" :label="$t('RailwayExport.ETA2')">
            <el-date-picker v-model="job.eta" no="eta" type="date" value-format="yyyy-MM-dd" clearable />
          </el-form-item>
          <el-form-item v-show="job.lob==='RI'">
            <span slot="label" class="blue">{{ $t('RailwayExport.ETA2') }}</span>
            <el-date-picker v-model="job.eta" no="eta" type="date" value-format="yyyy-MM-dd" clearable />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.departureStation') }}
            </span>
            <div style="display: flex">
              <cargo-advance-select
                no="departureStation"
                :select-type="TYPE_NAMES.basic_data_RailwayStation"
                filterable
                :default-value="job.departureStation"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="departureStationChange"
              />
              <el-checkbox
                v-model="job.transfer"
                no="transfer"
                style="width:80px; padding-left: 5px;"
              >{{ $t('SeaExport.Transit') }}</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item
            v-show="job.transfer"
          >
            <span slot="label" class="blue">
              {{ $t('RailwayExport.transferStation') }}
            </span>
            <cargo-advance-select
              no="transferStation"
              :select-type="TYPE_NAMES.basic_data_RailwayStation"
              filterable
              :default-value="job.transferStation"
              @parentCallBack="p=>{job.transferStation=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.transitStation') }}
            </span>
            <cargo-advance-select
              no="transitStation"
              :select-type="TYPE_NAMES.basic_data_RailwayStation"
              filterable
              :default-value="job.transitStation"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{job.transitStation=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.destinationStation') }}
            </span>
            <cargo-advance-select
              no="destinationStation"
              :select-type="TYPE_NAMES.basic_data_RailwayStation"
              filterable
              :default-value="job.destinationStation"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="destinationStationChange"
            />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.destinationCountry')">
            <cargo-advance-select
              no="destinationCountry"
              :select-type="TYPE_NAMES.basic_data_Country"
              filterable
              :default-value="job.destinationCountry"
              @parentCallBack="p=>{job.destinationCountry=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SolicitationType')">
            <cargo-advance-select
              no="cargoSource"
              filterable
              :select-type="TYPE_NAMES.local_cache_CargoSource"
              :default-value="job.cargoSource"
              :clearable="false"
              @parentCallBack="p=>{job.cargoSource=p.value;cargoSource_Change();txtCargoSourceChangeHandler()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              ref="customJobType"
              no="customJobType"
              :select-type="TYPE_NAMES.basic_data_CutomJobType"
              filterable
              :static-options="getCustomJobType"
              :default-value="job.customJobType"
              :placeholder="$t('Message.PleaseSelect')"
              @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.portAgent')">
            <cargo-advance-select
              no="portAgent"
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{companyLob:'railwayExport',portAgent:true,active:true}"
              filterable
              :default-value="job.portAgent||''"
              @parentCallBack="p=>{job.portAgent=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.forwardingAgent')">
            <cargo-advance-select
              no="forwardingAgent"
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{companyLob:'railwayExport',forwardingAgent:true,active:true}"
              filterable
              :default-value="job.forwardingAgent||''"
              @parentCallBack="p=>{job.forwardingAgent=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('queryJob.destinationAgent')">
            <cargo-company-select
              ref="destinationAgent"
              no="destinationAgent"
              :method-params="{overseaAgent:true,active:true,companyLob:'railwayExport'}"
              :check-credit="true"
              :job="job"
              :default-value="job.destinationAgent||''"
              filterable
              :headers="[$t('Partners.englishName')]"
              :fields="['englishName']"
              tag-name="englishName"
              style="width:300px;"
              @change="txtDestinationAgentChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="job.cargoSource==='NC'">
            <span slot="label" class="blue">{{ $t('queryJob.nominatedAgent') }}</span>
            <cargo-company-select
              no="designationAgent"
              :method-params="{designationAgent:true,active:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.designationAgent||''"
              tag-name="englishName"
              placeholder=" "
              style="width:300px;"
              @change="txtDesignationAgentChangeHandler"
            />
          </el-form-item>
          <el-checkbox
            v-model="job.diffPlacesCollaborate"
            no="diffPlacesCollaborate"
            class="blue"
          >{{ $t('RailwayExport.isDiffPlacesCollaborate') }}</el-checkbox>
          <el-form-item :label="$t('RailwayExport.loadingPlaceCompany')">
            <cargo-company-select
              no="loadingPlaceCompany"
              :method-params="{companyLob:'railwayExport',loadingPlaceCompany:true,active:true}"
              :check-credit="true"
              :job="job"
              :tooltip="true"
              tooltip-tag-name="englishName"
              :default-value="job.loadingPlaceCompany||''"
              style="width:300px;"
              @change="p=>{job.loadingPlaceCompany=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.signBillPlaceCompany')">
            <cargo-company-select
              no="signBillPlaceCompany"
              :method-params="{companyLob:'railwayExport',signBillPlaceCompany:true,active:true}"
              :check-credit="true"
              :job="job"
              :tooltip="true"
              tooltip-tag-name="englishName"
              :default-value="job.signBillPlaceCompany||''"
              style="width:300px;"
              @change="p=>{job.signBillPlaceCompany=p.value}"
            />
          </el-form-item>
          <el-checkbox
            v-model="job.fullShipment"
            no="fullShipment"
            class="blue"
          >{{ $t('RailwayExport.isFullShipment') }}</el-checkbox>
          <el-form-item :label="$t('RailwayExport.dischargePortCompany')">
            <cargo-company-select
              no="dischargePortCompany"
              :method-params="{companyLob:'railwayExport',dischargePortCompany:true,active:true}"
              :check-credit="true"
              :job="job"
              :tooltip="true"
              tooltip-tag-name="englishName"
              :default-value="job.dischargePortCompany||''"
              style="width:300px;"
              @change="p=>{job.dischargePortCompany=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.destinationPortCompany')">
            <cargo-company-select
              no="destinationPortCompany"
              :method-params="{companyLob:'railwayExport',destinationPortCompany:true,active:true}"
              :check-credit="true"
              :job="job"
              :tooltip="true"
              tooltip-tag-name="englishName"
              style="width:300px;"
              :default-value="job.destinationPortCompany||''"
              @change="p=>{job.destinationPortCompany=p.value}"
            />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="135px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.Consignee')" class="auto-width">
            <cargo-company-select
              no="consigneeId"
              :disabled="readonly"
              :method-params="{consignee:true,active:true}"
              :default-value="job.consigneeId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateConsigneeList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="consigneeChange"
            />&nbsp;
            <el-button
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="job['consigneeLine'+i]"
              :no="'consigneeLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">
              {{ $t('RailwayExport.paymentMethod') }}
            </span>
            <cargo-advance-select
              no="paymentMethod"
              :select-type="selectTypeNames.basic_data_PaymentMethod"
              :method-params="{companyLob:'railwayExport',paymentMethod:true,active:true}"
              filterable
              :default-value="job.paymentMethod"
              :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
              :tag-value="'code'"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{job.paymentMethod=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.vessel')">
            <el-input v-model="job.vessel" no="vessel" />
          </el-form-item>
          <el-form-item :label="$t('RailwayExport.voyageFlight')">
            <el-input v-model="job.voyageFlight" no="voyageFlight" />
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="job.containerLoadType" no="containerLoadType" @change="containerLoadType_Change()">
              <el-radio label="FCL">{{ $t('CargoMsg.Cargo_FCL') }}</el-radio>
              <el-radio label="LCL">{{ $t('CargoMsg.Cargo_DirectConsol') }}</el-radio>
              <el-radio label="BB">{{ $t('CargoMsg.Cargo_CoLoadConsol') }}</el-radio>
              <el-radio label="BC">Buyer Console</el-radio>
              <el-radio label="BULK">{{ $t('CargoMsg.Cargo_BulkCargo') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-show="job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
            class="auto-width"
          >
            <booking-sea-eq-data-grid
              ref="bookingSeaEqDataGrid"
              :value="seaEqList"
              :container-load-type="job.containerLoadType"
              :is-edit="isEdit"
              :job="job"
              lob="RE"
              :hide-soc="true"
              style="width: 260px"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CargoType')">
            <cargo-advance-select
              no="cargoType"
              :select-type="TYPE_NAMES.basic_data_CargoType"
              :headers="[$t('Partners.chineseName')]"
              :fields="['chineseName']"
              :filter-field-names="['chineseName']"
              :method-params="{sea:true}"
              filterable
              :clearable="false"
              :default-value="job.cargoType"
              @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChange()}"
            />
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 135px">{{ $t('SeaExport.CommissionedNumberOfPackages') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  @change="SEUtils.changeQWCRule(()=>{job.quantityActual=job.quantityContract},null)"
                />
                <span>&nbsp;</span>
              </div>
              <label>{{ $t('SeaExport.ActualQuantity') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.quantityActual"
                  no="quantityActual"
                  :precision="0"
                  :min="0"
                  @change="SEUtils.changeQWCRule(null,()=>{job.quantityContract=job.quantityActual})"
                />
                <span>&nbsp;</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 135px">{{ $t('SeaExport.CommissionedGrossWeight') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="SEUtils.changeQWCRule(()=>{job.weightActual=job.weightContract},null)"
                />
                <span>KGS</span>
              </div>
              <label>{{ $t('SeaExport.ActualWeight') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.weightActual"
                  no="weightActual"
                  :precision="3"
                  :min="0"
                  @change="SEUtils.changeQWCRule(null,()=>{job.weightContract=job.weightActual})"
                />
                <span>KGS</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 135px">{{ $t('SeaExport.CommissionedVolume') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  @change="SEUtils.changeQWCRule(()=>{job.cubageActual=job.cubageContract},null)"
                />
                <span>M³</span>
              </div>
              <label>{{ $t('SeaExport.ActualVolume') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :min="0"
                  @change="SEUtils.changeQWCRule(null,()=>{job.cubageContract=job.cubageActual})"
                />
                <span>M³</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')" class="auto-width">
            <cargo-packing-select
              no="packing"
              :disabled="readonly"
              :default-value="job.packing"
              placeholder=" "
              style="width: 260px;"
              @change="p=>{job.packing=p.value}"
            />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="135px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.NotifyParty')" class="auto-width">
            <cargo-company-select
              no="notifyId"
              :disabled="readonly"
              :method-params="{notify:true,active:true}"
              :default-value="job.notifyId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateNotifyList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="notifyChange"
            />&nbsp;
            <el-button
              no="billAddressDialogVisible"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="job['notifyLine'+i]"
              :no="'notifyLine'+i"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoChineseName"
              no="cargoChineseName"
              :disabled="!isEdit"
              :auto-uppercase="false"
              :auto-half-word="false"
              style="height: 65px;min-height: 65px; flex:1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val}, true, {autoUppercase:true})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoEnglishName"
              no="cargoEnglishName"
              :text-chars="0"
              :warning-count="-1"
              :disabled="!isEdit"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 65px;min-height: 65px;flex:1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val}, isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HsCode')">
            <el-input
              v-model="job.hsCode"
              no="hsCode"
              type="textarea"
              :rows="3"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{job.hsCode=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')">
            <cargo-rich-textarea
              v-model="job.mark"
              no="mark"
              :text-chars="0"
              :warning-count="-1"
              :disabled="!isEdit"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 65px;min-height: 65px;flex:1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
            <cargo-advance-select
              no="cargoCode"
              :select-type="TYPE_NAMES.basic_data_CargoInformation"
              :disabled="readonly"
              filterable
              :clearable="true"
              :default-value="job.cargoCode"
              :allow-create="false"
              @parentCallBack="p=>{cargoCodeChange(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="job.cargoName"
              no="cargoName"
              :disabled="!(isEdit && job.cargoCode!='' && job.cargoCode!=null)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsBroker')">
            <cargo-advance-select
              no="customsBroker"
              :disabled="!job.customs"
              :select-type="TYPE_NAMES.basic_data_Company"
              :data-filter-function="customsBrokerFilter"
              filterable
              :default-value="job.customsBroker||''"
              :placeholder="$t('SeaExport.PleaseTickCustomsDeclarationOption')"
              :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
              @parentCallBack="p=>{customsBrokerChangeHandler(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
            <cargo-advance-select
              no="customsDeclarationType"
              :disabled="!job.customs"
              :select-type="TYPE_NAMES.basic_data_CustomsDeclarationType"
              filterable
              :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
              :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
              @parentCallBack="p=>{job.customsDeclarationType=p.value}"
            />
          </el-form-item>
          <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageCompany')">
            <cargo-company-select
              no="landTransportation"
              :disabled="!job.landTransportation"
              :method-params="{truckCmp:true,active:true}"
              :default-value="job.carryingCmp||''"
              :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
              :custom-style="'width:260px'"
              @change="carryingCmpChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('SeaExport.Door')">
            <el-select
              v-model="truckingInfo.doorName"
              no="doorName"
              value-key="name"
              clearable
              filterable
              :allow-create="true"
              @change="doorsChangeHandler"
            >
              <el-option
                v-for="(item,index) in doorList"
                :key="index"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('Payment.contactPerson')">
            <div style="display:flex">
              <el-input v-model="truckingInfo.doorMan" no="doorMan" class="short-el-input" :placeholder="$t('Payment.contactPerson')" />
              <div style="width: 60px;padding:0 10px;font-size: 12px;text-align: right;">{{ $t('SeaExport.Tel') }}</div>
              <el-input v-model="truckingInfo.doorManTel" no="doorManTel" class="short-el-input" :placeholder="$t('SeaExport.Tel')" />
            </div>
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('SeaExport.DoorAddress')">
            <el-input v-model="truckingInfo.doorAddr" no="doorAddr" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="100px"
          label-position="left"
        >
          <el-form-item :label="$t('SeaExport.SecondNotifyParty')" class="auto-width">
            <cargo-rich-textarea
              v-model="job.alsoNotify"
              no="alsoNotify"
              :disabled="readonly"
              :text-chars="0"
              style="width: 260px;height: 216px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
            />
          </el-form-item>
          <el-form-item class="auto-width">
            <special-requests-grid
              ref="selectedSpecialRequest"
              v-model="job.satisfiedRequests"
              no="satisfiedRequests"
              :is-edit="isEdit"
              :customer-id="job.customerId"
              :lob="job.lob"
              :job="job"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Remarks')" class="auto-width">
            <el-input
              v-model="job.remarks"
              no="remarks"
              type="textarea"
              :rows="4"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField1')" class="auto-width">
            <el-input v-model="job.userDefinedField1" no="userDefinedField1" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField2')" class="auto-width">
            <el-input v-model="job.userDefinedField2" no="userDefinedField2" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField3')" class="auto-width">
            <el-input v-model="job.userDefinedField3" no="userDefinedField3" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField4')" class="auto-width">
            <el-input v-model="job.userDefinedField4" no="userDefinedField4" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TaxNature')">
            <el-select
              v-model="job.taxNature"
              no="taxNature"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in TAX_NATURES"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>&nbsp;
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :own-permission="hasChooseOwnTransceiverPermission"
      :customer-cmp-list="customerCmpList"
      :use-empty-customer-cmp-list="true"
      @callback="codeSearchCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tabReBookingJS from './tabReBooking.js'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoRequireAdvanceSelect from '@/components/Cargo/Common/cargoRequireAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRequireSelect from '@/components/Cargo/Common/cargoRequireSelect'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { Trucking } from '@/class/model/booking/Trucking'
import cargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { loadSpecificBasicInfo } from '@/api/cache'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { PAYMENTMETHOD_TYPES } from '@/class/cargo/model/parameters/PaymentMethod'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { RATE_TYPE, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabReBooking',
  components: {
    cargoAdvanceSelect, cargoCompanySelect, cargoUserSelect, cargoDepartmentSelect, cargoDepartmentNewSelect, cargoRequireAdvanceSelect, cargoSalesCompanySelect,
    cargoInput, cargoRichTextarea, cargoPackingSelect, cargoRequireSelect, billAddressDialog, bookingSeaEqDataGrid, specialRequestsGrid, AutoNumberInput
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      accountObjectControlMode: 0,
      PAYMENTMETHOD_TYPES,
      selectTypeNames: TYPE_NAMES,
      salesOfficeCheck: false, // 是否按照分公司控制 (0:开启分公司过滤 1:关闭分公司过滤)
      validateCustomerSales: false,
      isSpecifiedSalesBusiness: false,
      openProjectConfig: false,
      isHc: false,
      TAX_NATURES,
      rateType: RATE_TYPE,
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      addrPM: new BillAddressCommonPM(this),
      job: new RailwayExportJob().fillDefaultValue().getData(),
      truckingInfo: new Trucking().fillDefaultValue().getData(),
      customerCmpList: null,
      contactList: [],
      csrList: null,
      cargoSalesList: null,
      salesList: null,
      txtSalesOffice: '', // 销售所在分公司
      dcList: null,
      vesselList: [],
      voyages: [],
      doorList: [],
      billAddressDialog: {
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoUppercase: false
        }
      },
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      poNoRed: false,
      needConfirmProjectNo: false,
      isProjectLinkedCustomer: false,
      privateShipperList: [], // 当前登录用户服务人员是自己的发货人列表
      privateConsigneeList: [], // 当前登录用户服务人员是自己的收货人列表
      privateNotifyList: [], // 当前登录用户服务人员是自己的通知人列表
      hasChooseOwnTransceiverPermission: false, // 是否有选择自己作为收发通的权限
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      creditOpen: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isShowContactPersonDetail: false, // 海创显示详细信息
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    electricBusinessBtnEnable() {
      return !this.$checkPermission(['role_ElectricBusiness']) || this.context.user.admin
    },
    seaEqList() {
      return this.job.seaEQ || []
    },
    getCustomJobType() {
      return getCacheListByKey(TYPE_NAMES.basic_data_CutomJobType).filter(item => item.type === this.job.lob && item.active)
    }
  },
  async created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.SEUtils = SEUtils
    this.editVesselVoyageMode = 2 // 船名编辑模式
    loadSpecificBasicInfo('Vessel').then(res => {
      this.vesselList = res.data
    })
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
    this.isUppercaseByConfig = await JobUtils.uppercaseCargoEnglishNameAndMark()
  },
  methods: tabReBookingJS.methods
}
</script>

<style scoped lang="scss">
  #app .section.top::v-deep {
    .job-no-color.el-input {
      .el-input__inner {
        background: #ffffcc !important;
      }
    }
    .el-form-item__content {
      display: inline-block;
      flex-direction: unset;
    }
  }
  #app .section ::v-deep {
    .el-form-item__content {
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      .el-date-editor {
        width: 100%;
      }
      .short-item-input{
        width: 360px;
        display: inline-block;
        &::after{
          clear: both;
        }
        label{
          float: left;
          width: 65px;
          height: 31px;
          line-height: 31px;
          font-weight: normal;
          text-align: right;
          padding-right: 5px;
          box-sizing: border-box;
          &:nth-of-type(1){
            width: 100px;
            text-align: left;
          }
        }
        .short-input{
          float: left;
          width: 95px;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          border: 1px solid #DCDFE6;
          background-color: #fff;
          .el-input{
            vertical-align: middle;
            input{
              width: 63px;
              border: none;
            }
          }
          & > span{
            width: 30px;
            vertical-align: middle;
            padding: 1px 3px 0 0;
            color: #999;
            font-size: 12px;
          }
          &:nth-of-type(1){
            margin-right: 5px;
          }
        }
        .short-input-disabled{
          background-color: #f3f4f5;
        }
      }
      input{
        //width: 260px;
      }
      .input2 {
        width: 260px;
      }
      .shipper-input{
        width: 190px;
        margin-right: 5px;
        display: inline-block;
        .cargo-advance-select-wrapper{
          width: 190px;
          input{
            width: 190px;
          }
        }
      }
      .shipper-input-en{
        width: 148px;
        margin-right: 5px;
        display: inline-block;
        .cargo-advance-select-wrapper{
          width: 148px;
          input{
            width: 148px;
          }
        }
      }
      .short-el-input{
        width: 100px;
        input{
          width: 100px;
        }
      }
      .port-item{
        input{
          width: 100%;
        }
      }
    }
    .form-item-w260 {
      .el-form-item__content {
        width: 260px;
      }
    }
    .auto-width {
      .el-form-item__content {
        width: auto;
      }
    }
    .el-checkbox {
      margin-right: 15px;
    }
    .el-radio-group{
      white-space: normal;
      .el-radio {
        margin-right: 15px;
        padding: 5px 0;
      }
    }
  }
  .poNoClass {
    /deep/ .el-input.is-disabled .el-input__inner {
      color: red !important;
    }
  }
</style>
